import axios from "axios";
import Cookies from "js-cookie";
import { ReducerTypes } from "shared/types/reducerTypes";

let baseURL = "https://us-central1-devchallenges-1234.cloudfunctions.net/api";

if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
  baseURL = "http://localhost:5001/devchallenges-1234/us-central1/api";
}

export const apiCalls = async (
  {
    method,
    data,
    url,
    headers,
  }: {
    method: "get" | "post" | "put" | "delete";
    data?: any;
    url: string;
    headers?: any;
  },
  dispatch?: ({ type }: { type: string }) => void
) => {
  try {
    const res = await axios.create({
      baseURL,
    })({
      method,
      data,
      url,
      headers: {
        ...headers,
        session: Cookies.get("session"),
        csrf: Cookies.get("csrf"),
        "Set-Cookie": "HttpOnly;Secure;SameSite=Strict",
      },
    });

    return res;
  } catch ({ response }) {
    if (!dispatch) {
      return;
    }

    if (!response?.data?.error) {
      return;
    }

    if (response?.data?.error?.code === "auth/id-token-expired") {
      dispatch({ type: ReducerTypes.sessionExpired });
    }

    if (response?.data?.error?.code === "auth/argument-error") {
      dispatch({ type: ReducerTypes.requireLogin });
    }

    if (response?.data?.error === "unexcepted-error") {
      dispatch({ type: ReducerTypes.unexpectedError });
    }
  }
};
export default apiCalls;
